export default __webpack_public_path__ + "b60cb62870b1a38f1919e8f0c4dd9acf.svg";